{
  "version": 1,
  "asset_id": "16a4ab65-fcb0-4f7c-abe2-b896cadce060",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/16a4ab65-fcb0-4f7c-abe2-b896cadce060/wordmark-600.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/16a4ab65-fcb0-4f7c-abe2-b896cadce060/wordmark-600.png",
  "original_filename": "wordmark-600.png",
  "size": 40616,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:19:16Z"
}
